<div class="wholePage">
<div class="purplePortion">
  <img style="z-index: 10000;position: relative;margin-top: 3.5%;
  margin-left: 6%;" src="../../../../assets/images/KlickLogo.svg" alt="">
  <img style="position: absolute;left: 0;height: 50%;" src="../../../../assets/images/KlickitArrowsLeft.svg" alt="">

</div>
<div class="whiteCircle">
  <img src="../../../../assets/images/ThankYouIcon.svg" alt="">
</div>

<div class="whitePortion">
  <div class="middleText">
    <div class="middleText">
  <p class="thankYou">
    Thank you!
  </p>
  <p class="subtitle">
    Your registration form has been submitted successfully
  </p>
  </div>
</div>
</div>
</div>
